/* eslint-disable no-useless-concat */
/* eslint-disable no-mixed-operators */
import React from 'react';
import { connect } from 'react-redux';
import logo from '../../../assets/images/pmag.png'
import * as moment from 'moment';
import 'moment/locale/pt-br';
import './styles.css'

const LaudoEmitido = ({data: {AreaDeFuncionamento: areaDeFuncionamento,
  Identificacao: identificacao,
  Informacoes: informacoes,
  Poluicao: poluicao,
  Residuos: residuos }}) => {
  const agora = moment().format(" DD [de] MMMM [de] YYYY")
  moment.locale('pt-br');

  const formatTime = (data) => {
    const newData = data.split(':')
    return `${newData[0]}h${newData[1]}`
  }

  const Verificador = (data, type, option)  => {
    const state = data[type][option]

    const verificacao = state.reduce((acumulador, valorAtual) => {
      if(valorAtual.isChecked === true ) {
        acumulador.push(` ${valorAtual.label}`)

        if(valorAtual.label === 'Outros' ){
          acumulador.push(`${valorAtual.value}`)
        }
      }
      return acumulador
    }, [])

    const newState = () => {
      let ver = verificacao
      if(verificacao.length > 0 ) {
        ver = verificacao.join()
      }else {
        ver = 'Nenhum'
      }
      return ver
    }
     return newState()
  }
  const VerificadorHorario = (data, type, option)  => {
    const state = data[type][option]

    const verificacao = state.reduce((acumulador, valorAtual) => {
      if(valorAtual.isChecked === true  && valorAtual.label === 'Outros' ){
        acumulador.push(` ${valorAtual.label}: ${valorAtual.value}
         com o inicio de ${formatTime(valorAtual.Horarios.inicio)} até as ${formatTime(valorAtual.Horarios.fim)}`)

      }else if (valorAtual.isChecked === true ){
          acumulador.push(` ${valorAtual.label}
          com o inicio de ${formatTime(valorAtual.Horarios.inicio)} até as ${formatTime(valorAtual.Horarios.fim)}`)
      }
      return acumulador
    }, [])

    const newState = () => {
      let ver = verificacao
      if(verificacao.length > 0 ) {
        ver = verificacao.join()
      }else {
        ver = 'Nenhum'
      }
      return ver
    }
     return newState()
  }

  return (
    <div className="container-laudo">
      <div className="logo">
        <img src={logo} alt="SECRETARIA DE MEIO AMBIENTE" height="75"/>
        <strong>Secretaria Municipal de Meio Ambiente e Sustentabilidade</strong>
      </div>
      <h1 className='tituloForm'>REQUERIMENTO DE LICENÇA AMBIENTAL DECLARATÓRIA</h1>
      <div className="laudo">

        <div className='border-box'>
          <h2 className="title">1.  Dados Cadastrais </h2>

          <div className="box-container">
            <div>
              <span className="labelEmissao" >Razão Social: </span>
              <span className="valueEmissao" >{identificacao.razaoSocial}</span>
            </div>
            <div>
              <span className="labelEmissao">Nome Fantasia: </span>
              <span className="valueEmissao" >{identificacao.nomeFantasia}</span>
            </div>
            <div>
              <span className="labelEmissao">Código e Ramo das Atividades Econômicas: </span>
              {identificacao.atividades.map((item, index) =>
                <span key={index} className="selectMap" >{`${item.codigo} - ${item.descricao}; `}</span>)
              }
            </div>
            <div>
              <span className="labelEmissao">Endereço: </span>
              <span className="valueEmissao" >{identificacao.endereco +', '+ identificacao.bairro.descricao}</span>
            </div>
            <div className="camposMenores" >
              <div>
                <span className="labelEmissao">Cpf / Cnpj: </span>
                <span className="valueEmissao" >{identificacao.cpfCnpj}</span>
              </div>
              <div>
                <span className="labelEmissao">Inscrição Municipal: </span>
                <span className="valueEmissao" >{identificacao.inscricaoMunicipal}</span>
              </div>
            </div>
            <div>
              <span className="labelEmissao">Responsável pela empresa: </span>
              <span className="valueEmissao" >{identificacao.responsavel}</span>
            </div>
            <div className="camposMenores">
              <div>
                <span className="labelEmissao" >Cargo: </span>
                <span className="valueEmissao" >{identificacao.cargo}</span>
              </div>
              <div>
                <span className="labelEmissao">Telefone da Empresa: </span>
                <span className="valueEmissao" >{identificacao.telefone}</span>
              </div>
              </div>
            <div>
              <span className="labelEmissao">WhatsApp: </span>
              <span className="valueEmissao" >{identificacao.whatsapp}</span>
            </div>
          </div>
        </div>

        <div className="box-column-flex">
          <div className='border-box'>
            <h2 className="title">2.  Quadro de Áreas </h2>

            <div className="box-container">
              <div>
                <span className="labelEmissao" >Área Construída (m²): </span>
                <span className="valueEmissao" >{ (areaDeFuncionamento.areaConstruida)+' m²' }</span>
              </div>
              <div>
                <span className="labelEmissao" >Área Livre (m²):  </span>
                <span className="valueEmissao" >{ (areaDeFuncionamento.areaLivre)+' m²' }</span>
              </div>
              <div>
                <span className="labelEmissao" >Área Total (m²):  </span>
                <span className="valueEmissao" >{ (areaDeFuncionamento.areaTotal)+' m²' }</span>
              </div>
            </div>
          </div>

          <div className='border-box'>
            <h2 className="title">3.  Dados de Funcionamento</h2>

            <div className="box-container">
              <div>
                <span className="labelEmissao" >Periodo de Funcionamento: </span>
                <span className="valueEmissao" >{ 'de '+ (formatTime(areaDeFuncionamento.inicioExpediente))+' até as ' +(formatTime(areaDeFuncionamento.fimExpediente)) }</span>
              </div>
              <div>
                <span className="labelEmissao" >Numero de Funcionarios:  </span>
                <span className="valueEmissao" >{(areaDeFuncionamento.funcionarios)}</span>
              </div>
              <div>
                <span className="labelEmissao" >Fonte de Abastecimento de Água: </span>
                <span  className="valueEmissao" >
                  {areaDeFuncionamento.fonteAbastecimentoDeAgua === 'Outros' ?
                  `${areaDeFuncionamento.fonteAbastecimentoDeAgua}:
                  ${areaDeFuncionamento.fonteAbastecimentoDeAguaOutro}`:
                  areaDeFuncionamento.fonteAbastecimentoDeAgua }
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className='border-box'>
          <h2 className="title">4.  Fontes de Poluição </h2>

          <div className="box-container">
            <div className="divFlexFontespoulicao">
              <div>
                  <h3 className="fontesPoluicao">Residuos Solidos</h3>
                <div className="valueEmissao">
                  <span className="labelEmissao">Tipos de Residuos Solidos:  </span>
                  {Verificador(residuos, 'Solidos', 'Tipos')}
                </div>
                <div className="valueEmissao">
                  <span className="labelEmissao">Armazenamento de Residuos Solidos:  </span>
                  {Verificador(residuos, 'Solidos', 'Armazenamentos')}
                </div>
                <div className="valueEmissao">
                  <span className="labelEmissao">Destino de Residuos Solidos:  </span>
                  {Verificador(residuos, 'Solidos', 'Destino')}
                </div>
                  <h3 className="fontesPoluicao">Residuos Liquidos</h3>
                <div className="valueEmissao">
                  <span className="labelEmissao">Tipos de Residuos Liquidos:  </span>
                  {Verificador(residuos, 'Liquidos', 'Tipos')}
                </div>
                <div className="valueEmissao">
                  <span className="labelEmissao">Tratamento de Residuos Liquidos:  </span>
                  {Verificador(residuos, 'Liquidos', 'Tratamento')}
                </div>
                <div className="valueEmissao">
                  <span className="labelEmissao">Destino de Residuos Liquidos:  </span>
                  {Verificador(residuos, 'Liquidos', 'Destino')}
                </div>
              </div>

              <div className= "divSonora">
                  <h3 className="fontesPoluicao">Poluição Sonora</h3>

                  <span className="labelEmissao">Fontes de Poluição Sonora:  </span>
                <div className="select">
                  {VerificadorHorario(poluicao, 'Sonora', 'Fonte')}
                </div>
                <div className="valueEmissao">
                  <span className="labelEmissao">Medida de Controle Poluição Sonora:  </span>
                  {Verificador(poluicao, 'Sonora', 'Controle')}
                </div>

                <h3 className="fontesPoluicao">Poluição do Ar</h3>

                <div className="valueEmissao">
                  <span className="labelEmissao">Medida de Origem Poluição do Ar:  </span>
                  {Verificador(poluicao, 'Ar', 'Origem')}
                </div>
                <div className="valueEmissao">
                    <span className="labelEmissao">Medida de Controle Poluição do Ar:  </span>
                    {Verificador(poluicao, 'Ar', 'Controle')}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='border-box'>
          <h2 className='title' >5.  Outras Informações</h2>

          <div className="box-container">
            <div>
              <span className='informacoesValue' >{informacoes.OutrasInformacoes}</span>
            </div>
          </div>
        </div>
        <div>
          <div style={{marginTop:"50px"}}>
            <p><span className='declaracoes' > Ciente de que, ao prestar informações incorretas estarei sujeito às penalidades impostas pelo Decreto Federal 6514/2008, art. 3, tais como: suspensão da licença, interdição e multa; certifico que as informações prestadas acima estão corretas e são verdadeiras. Sendo assim, dou fé e firmo o presente.</span></p>
          </div>
        </div>
        <div>
          <div className= 'divDataEmissao'>
            <p><span className= 'dataEmissao' >{`Aparecida de Goiania, ${agora}`}</span></p>
          </div>
        </div>
        <div>
          <div className='linha'>
            <p><span >
                __________________________________________________________
              </span>
            </p>
              <p>
                Assinatura do responsável legal
              </p>
          </div>
        </div>
     </div>
    </div>
  )
}

export default connect((state) => ({
  data: state.form,
}))(LaudoEmitido)
